export const ShareViaWizardSteps = {
  sharingMethodStep: 0,
  configurationStep: 1
};